import { Box } from '@mui/material';
import React from 'react';
import ElementDataRow from 'components/common/element-data/ElementDataRow';
import { ElementMetadataFieldName, IElementDataBusinessOwner } from 'components/common/element-data/types';
import ElementDataRowLabel from 'components/common/element-data/ElementDataRowLabel';
import ElementDataRowValue from 'components/common/element-data/ElementDataRowValue';
import { useSelector } from 'react-redux';
import { dispatchCustomEvent } from 'tools/events';
import { getFieldElementMetadataSettings } from 'components/common/element-data/functions';

export default function BusinessOwner(props: IElementDataBusinessOwner) {
    const {
        businessOwner: businessOwnerName = '',
        businessOwnerEmail = '',
        ownerEmailSubject = '',
        showOwnerIcon = true,
        settings,
    } = props;
    const fieldKey: ElementMetadataFieldName = 'business_owner';
    const { fieldMetadataDisplay, fieldMetadataOrder } = getFieldElementMetadataSettings(settings, fieldKey);

    const ownersConfiguration = useSelector((state: any) => state.auth.configuration.owners);
    const isAppPanel = settings?.isAppPanel;

    if (!fieldMetadataDisplay || !businessOwnerName) return null;

    return (
        <ElementDataRow order={fieldMetadataOrder}>
            <ElementDataRowLabel
                icon={showOwnerIcon ? { type: 'mi', value: 'user' } : undefined}
                iconIndent={!showOwnerIcon}
            >
                {ownersConfiguration.business_owner.label}
            </ElementDataRowLabel>
            <ElementDataRowValue>
                {isAppPanel ? (
                    <Box
                        component={'span'}
                        sx={{
                            color: 'primary.main',
                            cursor: 'pointer',
                        }}
                        onClick={() => {
                            dispatchCustomEvent('mi-concierge-panel', {
                                action: 'owner-click',
                                payload: {
                                    userType: ownersConfiguration.business_owner.label,
                                    userName: businessOwnerName,
                                    userMail: businessOwnerEmail,
                                },
                            });
                        }}
                    >
                        {businessOwnerName}
                    </Box>
                ) : (
                    <>
                        {businessOwnerEmail ? (
                            <Box
                                component={'a'}
                                href={`mailto:${businessOwnerEmail}${ownerEmailSubject ? '?subject=' + ownerEmailSubject : ''}`}
                            >
                                {businessOwnerName}
                            </Box>
                        ) : (
                            <Box component={'span'}>{businessOwnerName}</Box>
                        )}
                    </>
                )}
            </ElementDataRowValue>
        </ElementDataRow>
    );
}
